// extracted by mini-css-extract-plugin
export var headerCell = "_4y-1";
export var loadingSpinnerContainer = "_4y-4";
export var rowWrapper = "_4y-3";
export var standaloneTable = "_4y-5";
export var table = "_4y-0";
export var white = "_4y-2";